<script setup>
import { computed } from 'vue';
import { categoryMeta, priorityMeta } from '../utils/taskMeta';

const props = defineProps({
  task: { type: Object, required: true },
});
defineEmits(['edit']);

const cat = computed(() => categoryMeta(props.task.category));
const pri = computed(() => priorityMeta(props.task.priority));

const dueLabel = computed(() => {
  if (!props.task.dueDate) return null;
  const d = new Date(props.task.dueDate);
  return d.toLocaleDateString('pt-BR', { day: '2-digit', month: 'short' });
});

const isOverdue = computed(() => {
  if (!props.task.dueDate || props.task.status === 'concluida') return false;
  return new Date(props.task.dueDate) < new Date();
});
</script>

<template>
  <button
    type="button"
    class="w-full rounded-lg border border-n-strong/30 bg-n-background p-3 text-left shadow-sm transition hover:border-blue-400 hover:shadow"
    @click="$emit('edit', task)"
  >
    <div class="mb-2 flex items-start gap-2">
      <span
        class="flex size-6 shrink-0 items-center justify-center rounded-md"
        :class="[cat.color]"
      >
        <span :class="cat.icon" class="size-3" />
      </span>
      <p class="flex-1 text-sm font-semibold leading-tight text-n-slate-12">
        {{ task.title }}
      </p>
    </div>

    <div class="flex flex-wrap items-center gap-1.5 text-[10px]">
      <span class="rounded px-1.5 py-0.5 font-semibold" :class="[pri.color]">
        {{ pri.label }}
      </span>
      <span
        v-if="dueLabel"
        class="inline-flex items-center gap-1 rounded px-1.5 py-0.5"
        :class="[
          isOverdue
            ? 'bg-rose-100 text-rose-700'
            : 'bg-slate-100 text-slate-700',
        ]"
      >
        <span class="i-lucide-calendar size-2.5" />
        {{ dueLabel }}
      </span>
      <span
        v-if="task.checklist?.length"
        class="inline-flex items-center gap-1 rounded bg-slate-100 px-1.5 py-0.5 text-slate-700"
      >
        <span class="i-lucide-list-checks size-2.5" />
        {{ task.checklistProgress }}%
      </span>
    </div>
  </button>
</template>
